import { HasId } from '../../interfaces';

export class UserTypeahead implements HasId {
    public id: number;
    public firstName: string;
    public lastName: string;
    public title: string;
}


// WEBPACK FOOTER //
// ./src/models/typeaheads/UserTypeahead.tsx